module.exports = __webpack_public_path__ + "static/img/link-icon.ab565c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link-icon.png
// module id = WCQZ
// module chunks = 18